import { render, staticRenderFns } from "./Page_p.vue?vue&type=template&id=0ec60134&scoped=true"
import script from "./Page_p.vue?vue&type=script&lang=js"
export * from "./Page_p.vue?vue&type=script&lang=js"
import style0 from "./Page_p.vue?vue&type=style&index=0&id=0ec60134&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec60134",
  null
  
)

export default component.exports